import { render, staticRenderFns } from "./ModalTableComponent.vue?vue&type=template&id=d74dd542&scoped=true&"
import script from "./ModalTableComponent.vue?vue&type=script&lang=js&"
export * from "./ModalTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./ModalTableComponent.vue?vue&type=style&index=0&id=d74dd542&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74dd542",
  null
  
)

export default component.exports